import UFOLoadHold from '@atlassian/react-ufo/load-hold';
export default UFOLoadHold;